"use client";

import { useState } from "react";
import Image from "next/image";
import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

interface SkeletonImageProps {
  src: string;
  alt: string;
  className?: string;
  sizes?: string;
  skeletonClassName?: string;
}

/** Image with skeleton placeholder while loading. Use for hero/service images. */
export function SkeletonImage({
  src,
  alt,
  className,
  sizes,
  skeletonClassName = "rounded-2xl",
}: SkeletonImageProps) {
  const [loaded, setLoaded] = useState(false);
  return (
    <>
      {!loaded && (
        <Skeleton className={cn("absolute inset-0", skeletonClassName)} />
      )}
      <Image
        src={src}
        alt={alt}
        fill
        className={cn(
          "transition-opacity duration-500 ease-out",
          loaded ? "opacity-100" : "opacity-0",
          className
        )}
        sizes={sizes}
        onLoad={() => setLoaded(true)}
      />
    </>
  );
}
